import {mergeDeepRight} from 'ramda';

import {CorrectionType} from '@dms/api/shared';

import {ReceiveNoteCorrectionBasketItem} from '../types';

const getReceiveNoteCorrectionBasketItemMock = (
  config: Partial<ReceiveNoteCorrectionBasketItem> = {}
): ReceiveNoteCorrectionBasketItem =>
  mergeDeepRight(
    {
      id: '63e34f39-b5fc-4a88-82e8-29ef0efa8f58',
      name: 'testarticle30052',
      warehouse_id: '855bd140-6054-4d4b-beeb-2adbf5ee89b4',
      manufacturerNumber: 'testarticle30052',
      manufacturerId: '1a886c36-e6fc-11ee-bd3d-0242ac120002',
      quantity: 1,
      unit: 'bbc793ad-2b9d-4d0a-88a6-ae0cd6855409',
      dispensingUnit: 1,
      itemEditingAllowed: true,
      quantityEditingAllowed: true,
      correctionValue: -90,
      correctionType: 'RETURN_TO_SUPPLIER' as CorrectionType,
      unitPrice: {
        withoutVat: {
          amount: 90,
          currency: 'CZK',
        },
        withVat: {
          amount: 108.9,
          currency: 'CZK',
        },
      },
      totalPrice: {
        withoutVat: {
          amount: -90,
          currency: 'CZK',
        },
        withVat: {
          amount: -108.9,
          currency: 'CZK',
        },
      },
      tooltip: [
        {
          label: 'Request type',
          value: '-',
        },
        {
          label: 'Warehouse',
          value: 'Hyundai CZ',
        },
        {
          label: 'Manufacturer',
          value: 'Other',
        },
        {
          label: 'Storage location',
          value: '-',
        },
        {
          label: 'Dispensing unit',
          value: '-',
        },
        {
          label: 'Discount rate',
          value: '-',
        },
        {
          label: 'Current margin',
          value: '-',
        },
        {
          label: 'Purchase price',
          value: '90 CZK',
        },
        {
          label: 'Recommended price',
          value: '-',
        },
        {
          label: 'Base sales price',
          value: '-',
        },
      ],
      minMaxQuantity: {
        minQuantity: 0.5,
        maxQuantity: 2,
      },
    },
    config
  );

export const metadaWarehouseReceiveNoteCorrectionBasketItemApiMock = {
  getReceiveNoteCorrectionBasketItemMock,
};
